import React, { forwardRef, useCallback, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useTheme } from 'styled-components';
import { Page } from '../../../Services/controllers/StepController';
import { useAnalytics } from '../../Contexts/AnalyticsContext';
import { useApplication } from '../../Contexts/ApplicationContext';
import { useNFT, useSettings } from '../../Contexts/SettingsContext';
import { LanguageSelectorButton } from '../LanguageSelector';
import { Arrow } from './Arrow';
import { BackArrow } from './BackArrow';
import { Burger } from './Burger';
import styles from './Header.module.css';
export const Header = observer(forwardRef(function Header(props, ref) {
    var _a, _b, _c;
    const theme = useTheme();
    const { orderToken, externalId } = useSettings();
    const { stepController: { goBack, currentStep, stepsHistory }, } = useApplication();
    const { track } = useAnalytics();
    const smartContractData = useNFT();
    const { orderFacade: { exchangeInfo }, } = useApplication();
    const handleLanguageSelectorClick = useCallback(() => {
        track('language_selector_opened', {
            step: currentStep.step,
        });
        props.onLanguageSelectorClick();
    }, [currentStep.step, props, track]);
    const handleMenuClick = useCallback(() => {
        track('hamburger_menu_viewed', {
            step: currentStep.step,
        });
        props.onBurgerClick();
    }, [currentStep.step, props, track]);
    const chipInfo = useMemo(() => {
        var _a, _b, _c;
        const toInfoNft = smartContractData === null || smartContractData === void 0 ? void 0 : smartContractData.name;
        return (<>
          <span className={styles.pay_info_chip_span}>
            {exchangeInfo.payAmountString}
          </span>
          <Arrow />
          {toInfoNft ? (<span className={styles.received_info_chip_span}>{toInfoNft}</span>) : (<>
              <span className={styles.received_info_chip_span} style={{ maxWidth: 60 }}>
                {Number(exchangeInfo === null || exchangeInfo === void 0 ? void 0 : exchangeInfo.amounts.to.amount)}
              </span>
              {'\u00A0'}
              <span className={styles.received_info_chip_span} style={{ maxWidth: 50 }}>
                {(_c = (_b = (_a = exchangeInfo === null || exchangeInfo === void 0 ? void 0 : exchangeInfo.amounts) === null || _a === void 0 ? void 0 : _a.to) === null || _b === void 0 ? void 0 : _b.currency) === null || _c === void 0 ? void 0 : _c.code}
              </span>
            </>)}
        </>);
    }, [
        exchangeInfo === null || exchangeInfo === void 0 ? void 0 : exchangeInfo.amounts.to.amount,
        (_c = (_b = (_a = exchangeInfo === null || exchangeInfo === void 0 ? void 0 : exchangeInfo.amounts) === null || _a === void 0 ? void 0 : _a.to) === null || _b === void 0 ? void 0 : _b.currency) === null || _c === void 0 ? void 0 : _c.code,
        exchangeInfo.payAmountString,
        smartContractData === null || smartContractData === void 0 ? void 0 : smartContractData.name,
    ]);
    const canGoBack = useMemo(() => {
        var _a;
        const hasSteps = stepsHistory.length > 0;
        const previousStep = (_a = stepsHistory[stepsHistory.length - 1]) === null || _a === void 0 ? void 0 : _a.step;
        const isNotOnMainPage = previousStep !== Page.MAIN;
        const isCheckOrderPage = currentStep.step === Page.CHECK_ORDER;
        if (isCheckOrderPage) {
            return false;
        }
        if (externalId) {
            return hasSteps && isNotOnMainPage && previousStep !== Page.PHONE;
        }
        if (orderToken) {
            return hasSteps && isNotOnMainPage;
        }
        return hasSteps;
    }, [externalId, orderToken, stepsHistory, currentStep.step]);
    const handleBackClick = useCallback(() => {
        props.customBackClick ? props.customBackClick() : goBack();
    }, [goBack, props]);
    const showBackArrow = !props.hideBackArrow && canGoBack;
    return (<header className="flex justify-between items-center gap-2 py-8 px-[--mobile-sides-padding] [@media(min-width:399px)]:px-[--web-sides-padding]" ref={ref}>
        <div className="min-w-8 flex items-center justify-start">
          {props.label ? (<p className={styles.label}>{props.label}</p>) : showBackArrow ? (<BackArrow dataTestId="back-button" onClick={handleBackClick} fill={theme.colors.textBodyMain}/>) : null}

          {props.headerChildren}
        </div>

        <div className="flex items-center justify-center">
          {!props.label && !props.hideChip && (<div className={styles.chip} data-test-id="header-chip">
              {chipInfo}
            </div>)}
        </div>

        <div className="flex items-center justify-end gap-2">
          {props.showLanguageSelectorButton && (<LanguageSelectorButton onClick={handleLanguageSelectorClick}/>)}
          <Burger onClick={handleMenuClick}/>
        </div>
      </header>);
}));
